export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-1.dc9e907e.jpg";